// extracted by mini-css-extract-plugin
module.exports = {"container":"BottomAdv_container__ACGJZ"};